import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BrandProvider } from "@/components/Brand/BrandProvider";
import { ContentsSection } from "@/components/Brand/ContentsSection";
import { ProfileSection } from "@/components/Brand/ProfileSection";
import { SnackbarProvider } from "@/components/Brand/SnackbarProvider";
import { useBrandQuery } from "@/components/Brand/queries/useBrandQuery";
import SEO from "@/components/SEO";
import { LayoutContainer } from "@/containers/Layout/Layout";
import defaultSeoConfig from "@/settings/next-seo.config";
import { getCookies } from "cookies-next";
import React from "react";
import { getBrand } from "../../../api/brand";
export const BrandLayout = (param)=>{
    let { children , author , labDataResult  } = param;
    // SSR로 받은 브랜드 데이터를 React Query 캐시에 hydration
    useBrandQuery({
        name: labDataResult.name,
        initialData: labDataResult
    });
    var _labDataResult_ogTitle, _labDataResult_ogDescription, _labDataResult_ogDescription1;
    const metadata = {
        title: (_labDataResult_ogTitle = labDataResult === null || labDataResult === void 0 ? void 0 : labDataResult.ogTitle) !== null && _labDataResult_ogTitle !== void 0 ? _labDataResult_ogTitle : defaultSeoConfig.title,
        description: (_labDataResult_ogDescription = labDataResult === null || labDataResult === void 0 ? void 0 : labDataResult.ogDescription) !== null && _labDataResult_ogDescription !== void 0 ? _labDataResult_ogDescription : defaultSeoConfig.description,
        keywords: labDataResult === null || labDataResult === void 0 ? void 0 : labDataResult.keyword,
        ogDescription: (_labDataResult_ogDescription1 = labDataResult === null || labDataResult === void 0 ? void 0 : labDataResult.ogDescription) !== null && _labDataResult_ogDescription1 !== void 0 ? _labDataResult_ogDescription1 : defaultSeoConfig.description,
        ogImage: labDataResult === null || labDataResult === void 0 ? void 0 : labDataResult.ogImage,
        ogUrl: "https://solvook.com/@".concat(labDataResult.name)
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SEO, {
                ...metadata
            }),
            /*#__PURE__*/ _jsx(SnackbarProvider, {
                children: /*#__PURE__*/ _jsx(BrandProvider, {
                    initialValues: labDataResult,
                    children: /*#__PURE__*/ _jsxs(LayoutContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(ProfileSection, {
                                data: labDataResult
                            }),
                            /*#__PURE__*/ _jsx(ContentsSection, {
                                children: children
                            })
                        ]
                    })
                })
            })
        ]
    });
};
export function withBrandLayout(PageComponent) {
    PageComponent.getLayout = (page)=>{
        const { props  } = page;
        return /*#__PURE__*/ _jsx(BrandLayout, {
            author: props.author,
            labDataResult: props.labDataResult,
            children: page
        });
    };
    return PageComponent;
}
export const BrandServerSideProps = async (context)=>{
    const { userId  } = context.query;
    const { accessToken  } = getCookies(context) || {};
    if (!userId) {
        return {
            notFound: true
        };
    }
    try {
        const labDataResult = await getBrand(userId.toString(), accessToken);
        return {
            props: {
                labDataResult
            }
        };
    } catch (error) {
        return {
            notFound: true
        };
    }
};
